import { useTranslation } from "react-i18next";
import { MdOutlineSell } from "react-icons/md";
import Card from "shared/components/Card";
import Radio from "shared/components/Form/Radio";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { USERS } from "utils/api/graphql/queries/users";
import { GENDER, USER_TYPES } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";

const Advisor = ({ formProps, setFieldValue }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BROKER);
  const FORM = t("FORM", { returnObjects: true });
  return [
    <Card key="user" type={"simple"} head title={FORM.LEGAL_INFO}>
      <div className="grid--2">
        <Select
          mode="multiple"
          type="async"
          node={{
            query: USERS,
            variables: {
              where: {
                isActive: true,
                meta: { type: USER_TYPES.INTERNAL_SUPERVISOR.type },
              },
            },
            accessors: {
              root: "users.data",
              label: {
                separator: " ",
                keys: ["firstname", "lastname"],
              },
              value: "id",
            },
          }}
          placeholder={FORM.SUPERVISORS}
          label={FORM.SUPERVISORS}
          {...bindInputProps({
            name: "supervisors",
            ...formProps,
          })}
          onChange={(value) => setFieldValue("supervisors", value)}
        />
        <div></div>
        <Input
          placeholder={FORM.NETWORK}
          label={FORM.NETWORK}
          {...bindInputProps({ name: "user.meta.network", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.AGENCY}
          label={FORM.AGENCY}
          {...bindInputProps({ name: "user.meta.agency", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.AGENCY_EMAIL}
          label={FORM.AGENCY_EMAIL}
          {...bindInputProps({ name: "user.meta.emailAgency", ...formProps })}
        />
        <Radio
          isHorizontal={false}
          label={FORM.CIVILITY.LABEL}
          options={[
            {
              label: FORM.CIVILITY.MALE,
              value: GENDER.MALE,
            },
            {
              label: FORM.CIVILITY.FEMALE,
              value: GENDER.FEMALE,
            },
          ]}
          {...bindInputProps({ name: "user.gender", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.FIRST_NAME}
          label={FORM.FIRST_NAME}
          {...bindInputProps({ name: "user.firstname", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.LAST_NAME}
          label={FORM.LAST_NAME}
          {...bindInputProps({ name: "user.lastname", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.PHONE_AGENCY}
          label={FORM.PHONE_AGENCY}
          {...bindInputProps({ name: "user.phone", ...formProps })}
        />
        <Input
          placeholder={FORM.EMAIL}
          label={FORM.EMAIL}
          {...bindInputProps({ name: "user.email", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.ADDRESS}
          label={FORM.ADDRESS}
          {...bindInputProps({ name: "user.address", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.ZIP_CODE}
          label={FORM.ZIP_CODE}
          {...bindInputProps({ name: "user.zipCode", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.CITY}
          label={FORM.CITY}
          {...bindInputProps({ name: "user.city", ...formProps })}
          required
        />
        <Input
          placeholder={FORM.SELLER_CODE}
          label={FORM.SELLER_CODE}
          icon={<MdOutlineSell size={14} />}
          {...bindInputProps({ name: "meta.sellerCode", ...formProps })}
        />
      </div>
    </Card>,
  ];
};

export default Advisor;
